export default class DateDuration {

    private sign: string;
    private interval: number;
    private dateSign: string;

    /**
     * @param sign
     * @param interval
     * @param dateSign
     */
    constructor(sign: string, interval: number, dateSign: string) {
        this.sign = sign;
        this.interval = interval;
        this.dateSign = dateSign;
    }

    getSign(): string {
        return this.sign;
    }

    getInterval(): number {
        return this.interval;
    }

    getDateSign(): string {
        return this.dateSign;
    }
}





// WEBPACK FOOTER //
// ./src/Models/dateModels/DateDuration.ts